<template>
    <div class="intro-area bg-light pd-top-120 pd-bottom-90">
        <div class="container">
            <div class="row">
                <div class="col-lg-4 col-md-6">
                    <div class="intro-area-inner border-right-1 ps-lg-3">
                        <div class="thumb mb-4">
                            <img :src="require('@/assets/img/icon/1.png')" alt="img">
                        </div>
                        <div class="details">
                            <h4>La Mejor Calidad</h4>
                            <p>Estamos comprometidos con la excelencia y nos enorgullece la calidad de nuestro trabajo y la dedicación de nuestro equipo.</p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="intro-area-inner border-right-1 ps-lg-3 pe-lg-3">
                        <div class="thumb mb-4">
                            <img :src="require('@/assets/img/icon/2.png')" alt="img">
                        </div>
                        <div class="details">
                            <h4>Empresa Lider</h4>
                            <p>Nos enorgullece ser una empresa líder en el desarrollo de software y soluciones digitales.</p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="intro-area-inner ps-lg-3">
                        <div class="thumb mb-4">
                            <img :src="require('@/assets/img/icon/3.png')" alt="img">
                        </div>
                        <div class="details">
                            <h4>Equipo Calificado</h4>
                            <p>Contamos con un equipo talentoso de expertos en tecnología y desarrolladores apasionados por crear soluciones que marquen la diferencia.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Intro",
    }
</script>


// WEBPACK FOOTER //
// src/components/page/about/Intro.vue